var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"tooltip",staticClass:"knd-tooltip",class:{'show': _vm.show, 'viewport-small': _vm.smallViewport},style:({left: _vm.x +'px', top: _vm.y + 'px'})},[_c('div',{ref:"tooltip--wrapper",staticClass:"knd-tooltip-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }